export type VoicePermissionState = PermissionState | "unsupported" | "unknown";
export type VoiceModeState = "off" | "server";

export interface AudioInputDevice {
  deviceId: string;
  label: string;
}

export interface VoiceInputStateSummary {
  available: boolean;
  voiceMode: VoiceModeState;
  permission: VoicePermissionState;
  recording: boolean;
  processing: boolean;
  selectedDeviceLabel: string;
  lastTrace: string | null;
}

export function listUsableAudioInputs(devices: MediaDeviceInfo[]): AudioInputDevice[] {
  return devices
    .filter((device) => device.kind === "audioinput")
    .map((device, index) => ({
      deviceId: device.deviceId,
      label: device.label || (device.deviceId === "default"
        ? "System-Standardmikrofon (Name blockiert)"
        : `Mikrofon ${index + 1} (Name blockiert)`),
    }));
}

export function resolveSelectedAudioDeviceId(
  devices: Array<Pick<AudioInputDevice, "deviceId">>,
  selectedDeviceId: string,
): string {
  if (devices.length === 0) return "";
  if (devices.some((device) => device.deviceId === selectedDeviceId)) {
    return selectedDeviceId;
  }
  return devices[0]?.deviceId ?? "";
}

export function describeVoiceInputState(state: VoiceInputStateSummary): string {
  if (state.voiceMode === "off") return "Voice aus";
  if (!state.available) return "Mikrofon-API nicht verfügbar";
  if (state.permission === "denied") {
    return "Mikrofon blockiert · bitte Windows/Electron-Berechtigung pruefen";
  }
  if (state.recording) {
    return `Nimmt auf · ${state.selectedDeviceLabel || "Standard-Mikrofon"}${
      state.lastTrace ? ` · ${state.lastTrace}` : ""
    }`;
  }
  if (state.processing) return "Verarbeitet Aufnahme · STT läuft";
  if (state.permission === "granted") {
    return `Bereit · ${state.selectedDeviceLabel || "Standard-Mikrofon"}`;
  }
  return `Bereit zur Mikrofon-Prüfung${state.lastTrace ? ` · ${state.lastTrace}` : ""}`;
}
